import React from "react";
import { Create, SimpleForm, TextInput } from "react-admin";

const SchoolCreate = (props) => {
  const redirect = function(basePath, id, data) {
    console.log("SchoolCreate.redirect()", basePath, id, data);
    return `/schools`;
  };

  return (
    <Create {...props}>
      <SimpleForm redirect={redirect}>
        <TextInput source="name" />
        <TextInput source="slug" />
        <TextInput source="abbr" />
        <TextInput label="Logo URL" source="logoUrl" />
        <TextInput label="Stable ID" source="stableId" />
      </SimpleForm>
    </Create>
  );
};

export default SchoolCreate;
